/* Copia un texto al portapapeles. navigator.clipboard cuando existe; si no, textarea + execCommand.
   Rechaza si el texto está vacío o si el navegador no pudo copiar. */
export const copiarAlPortapapeles = async (valor) => {
  const texto = String(valor || "");
  if (!texto) throw new Error("EMPTY_TEXT");
  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(texto);
    return;
  }
  const input = document.createElement("textarea");
  input.value = texto;
  input.setAttribute("readonly", "readonly");
  input.style.position = "absolute";
  input.style.left = "-9999px";
  document.body.appendChild(input);
  try {
    input.select();
    if (!document.execCommand("copy")) throw new Error("COPY_FAILED");
  } finally {
    document.body.removeChild(input);
  }
};
